import * as React from "react"

import { cn } from "@/lib/utils"

// Debug: Vérifier que React.forwardRef est disponible
console.log("🔧 Input.tsx - React.forwardRef available:", !!React.forwardRef);

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-white px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm [touch-action:manipulation]",
          className
        )}
        autoComplete={props.autoComplete || "off"}
        autoCorrect={props.autoCorrect || "off"}
        autoCapitalize={props.autoCapitalize || "off"}
        spellCheck={props.spellCheck ?? true}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
